// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupCreate_leadersContainer__mCWa7 {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
.GroupCreate_leadersTitleContainer__0ImaO {
  column-gap: 8px;
  display: flex;
}
.GroupCreate_leadersTitle__gAUdE {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.GroupCreate_leadersNumber__GFDp8 {
  color: #9fa7b2;
  cursor: default;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 1px 0px 0px 0px;
}
.GroupCreate_cardsContainer__lD6qw {
  display: flex;
  column-gap: 40px;
  overflow: scroll;
}
.GroupCreate_addCard__VSUqe {
  align-items: center;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 218.5px;
  justify-content: center;
  padding: 16px;
  row-gap: 8px;
  width: 173px;
}
.GroupCreate_addCardIcon__MpQs4 {
  height: 24px;
  stroke: #828d9a;
  width: 24px;
}
.GroupCreate_addCardText__sx222 {
  color: #828d9a;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.GroupCreate_attendeesContainer__2mZkS {
  display: flex;
  flex-direction: column;
  margin: 53px 0px 40px;
  row-gap: 24px;
}
.GroupCreate_attendeesTitleContainer__lvDEE {
  column-gap: 8px;
  display: flex;
}
.GroupCreate_attendeesTitle__nEJlh {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.GroupCreate_attendeesNumber__iiSUS {
  color: #9fa7b2;
  cursor: default;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 1px 0px 0px 0px;
}
.GroupCreate_editContainer__QlWHy {
  column-gap: 24px;
  display: flex;
  margin-bottom: 40px;
  width: 100%;
}
.GroupCreate_editContainerBox__VppiI {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 100%;
}
.GroupCreate_colorsContainer__SVFtz {
  display: flex;
  justify-content: space-between;
}
.GroupCreate_colorContainer__O5vGh {
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  row-gap: 8px;
  width: 100%;
}
.GroupCreate_colorLabel__DxUk8 {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.GroupCreate_colorBox__KZ-lB {
  align-items: center;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 46px;
  padding: 0px 16px;
  row-gap: 8px;
}
.GroupCreate_color__CvsoZ {
  border: 1px solid #d8dbdf;
  border-radius: 4px;
  display: flex;
  height: 22px;
  width: 100%;
}
.GroupCreate_removeItemButton__n-CA5 {
  align-items: center;
  background-color: #e2e2e2;
  border-radius: 64px;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  margin: -16px 0px 0px 191px;
  position: absolute;
  width: 32px;
}
.GroupCreate_removeItemIcon__Mc5Tp {
  height: 16px;
  stroke: #5f6d7e;
  width: 16px;
}
.GroupCreate_colorPickInput__YzLBO {
  display: flex;
  justify-items: center;
  flex-direction: row;
}
.GroupCreate_colorPickInput__YzLBO span {
  height: 40px;
  width: 80%;
}
.GroupCreate_colorPickInput__YzLBO span span {
  height: 30px !important;
  width: 100% !important;
}
.GroupCreate_editActionsButtons__bdBAL {
  column-gap: 8px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.GroupCreate_cancelButton__BsOvC {
  align-items: center;
  background-color: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 52px;
  width: 212px;
}
.GroupCreate_cancelButtonText__Mps0L {
  color: #808080;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
}
.GroupCreate_saveButton__Gq2cf {
  align-items: center;
  background-color: #cb9c2d;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 52px;
  width: 212px;
}
.GroupCreate_saveButtonText__OkCaw {
  color: #ffffff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
}
.GroupCreate_colorPickIconBox__WbyjV {
  cursor: pointer;
  margin: auto 0px auto 10px;
}
.GroupCreate_colorPickIconBox__WbyjV span {
  height: 48;
  width: 150;
}
.GroupCreate_colorPickIcon__wOMNV {
  height: 18px;
  stroke: #5f6d7e;
  width: 18px;
}
.GroupCreate_programContainerBox__WCRXc {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media screen and (max-width: 950px) {
  .GroupCreate_editContainer__QlWHy,
  .GroupCreate_colorsContainer__SVFtz {
    flex-direction: column;
    gap: 24px;
  }
}

@media screen and (max-width: 430px) {
  .GroupCreate_colorsContainer__SVFtz {
    flex-direction: column;
    gap: 24px;
  }
  .GroupCreate_colorLabel__DxUk8,
  .GroupCreate_colorBox__KZ-lB {
    width: 100%;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/groups/components/groupCreate/GroupCreate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE;;IAEE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;;IAEE,WAAW;IACX,sBAAsB;EACxB;AACF","sourcesContent":[".leadersContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n}\n.leadersTitleContainer {\n  column-gap: 8px;\n  display: flex;\n}\n.leadersTitle {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.leadersNumber {\n  color: #9fa7b2;\n  cursor: default;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 1px 0px 0px 0px;\n}\n.cardsContainer {\n  display: flex;\n  column-gap: 40px;\n  overflow: scroll;\n}\n.addCard {\n  align-items: center;\n  border: 1px solid #e2e2e2;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 218.5px;\n  justify-content: center;\n  padding: 16px;\n  row-gap: 8px;\n  width: 173px;\n}\n.addCardIcon {\n  height: 24px;\n  stroke: #828d9a;\n  width: 24px;\n}\n.addCardText {\n  color: #828d9a;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.attendeesContainer {\n  display: flex;\n  flex-direction: column;\n  margin: 53px 0px 40px;\n  row-gap: 24px;\n}\n.attendeesTitleContainer {\n  column-gap: 8px;\n  display: flex;\n}\n.attendeesTitle {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.attendeesNumber {\n  color: #9fa7b2;\n  cursor: default;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 1px 0px 0px 0px;\n}\n.editContainer {\n  column-gap: 24px;\n  display: flex;\n  margin-bottom: 40px;\n  width: 100%;\n}\n.editContainerBox {\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n  width: 100%;\n}\n.colorsContainer {\n  display: flex;\n  justify-content: space-between;\n}\n.colorContainer {\n  display: flex;\n  flex-direction: column;\n  margin-right: 8px;\n  row-gap: 8px;\n  width: 100%;\n}\n.colorLabel {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.colorBox {\n  align-items: center;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  height: 46px;\n  padding: 0px 16px;\n  row-gap: 8px;\n}\n.color {\n  border: 1px solid #d8dbdf;\n  border-radius: 4px;\n  display: flex;\n  height: 22px;\n  width: 100%;\n}\n.removeItemButton {\n  align-items: center;\n  background-color: #e2e2e2;\n  border-radius: 64px;\n  cursor: pointer;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  margin: -16px 0px 0px 191px;\n  position: absolute;\n  width: 32px;\n}\n.removeItemIcon {\n  height: 16px;\n  stroke: #5f6d7e;\n  width: 16px;\n}\n.colorPickInput {\n  display: flex;\n  justify-items: center;\n  flex-direction: row;\n}\n.colorPickInput span {\n  height: 40px;\n  width: 80%;\n}\n.colorPickInput span span {\n  height: 30px !important;\n  width: 100% !important;\n}\n.editActionsButtons {\n  column-gap: 8px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.cancelButton {\n  align-items: center;\n  background-color: #ebebeb;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  height: 52px;\n  width: 212px;\n}\n.cancelButtonText {\n  color: #808080;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n}\n.saveButton {\n  align-items: center;\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  height: 52px;\n  width: 212px;\n}\n.saveButtonText {\n  color: #ffffff;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n}\n.colorPickIconBox {\n  cursor: pointer;\n  margin: auto 0px auto 10px;\n}\n.colorPickIconBox span {\n  height: 48;\n  width: 150;\n}\n.colorPickIcon {\n  height: 18px;\n  stroke: #5f6d7e;\n  width: 18px;\n}\n.programContainerBox {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n@media screen and (max-width: 950px) {\n  .editContainer,\n  .colorsContainer {\n    flex-direction: column;\n    gap: 24px;\n  }\n}\n\n@media screen and (max-width: 430px) {\n  .colorsContainer {\n    flex-direction: column;\n    gap: 24px;\n  }\n  .colorLabel,\n  .colorBox {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leadersContainer": `GroupCreate_leadersContainer__mCWa7`,
	"leadersTitleContainer": `GroupCreate_leadersTitleContainer__0ImaO`,
	"leadersTitle": `GroupCreate_leadersTitle__gAUdE`,
	"leadersNumber": `GroupCreate_leadersNumber__GFDp8`,
	"cardsContainer": `GroupCreate_cardsContainer__lD6qw`,
	"addCard": `GroupCreate_addCard__VSUqe`,
	"addCardIcon": `GroupCreate_addCardIcon__MpQs4`,
	"addCardText": `GroupCreate_addCardText__sx222`,
	"attendeesContainer": `GroupCreate_attendeesContainer__2mZkS`,
	"attendeesTitleContainer": `GroupCreate_attendeesTitleContainer__lvDEE`,
	"attendeesTitle": `GroupCreate_attendeesTitle__nEJlh`,
	"attendeesNumber": `GroupCreate_attendeesNumber__iiSUS`,
	"editContainer": `GroupCreate_editContainer__QlWHy`,
	"editContainerBox": `GroupCreate_editContainerBox__VppiI`,
	"colorsContainer": `GroupCreate_colorsContainer__SVFtz`,
	"colorContainer": `GroupCreate_colorContainer__O5vGh`,
	"colorLabel": `GroupCreate_colorLabel__DxUk8`,
	"colorBox": `GroupCreate_colorBox__KZ-lB`,
	"color": `GroupCreate_color__CvsoZ`,
	"removeItemButton": `GroupCreate_removeItemButton__n-CA5`,
	"removeItemIcon": `GroupCreate_removeItemIcon__Mc5Tp`,
	"colorPickInput": `GroupCreate_colorPickInput__YzLBO`,
	"editActionsButtons": `GroupCreate_editActionsButtons__bdBAL`,
	"cancelButton": `GroupCreate_cancelButton__BsOvC`,
	"cancelButtonText": `GroupCreate_cancelButtonText__Mps0L`,
	"saveButton": `GroupCreate_saveButton__Gq2cf`,
	"saveButtonText": `GroupCreate_saveButtonText__OkCaw`,
	"colorPickIconBox": `GroupCreate_colorPickIconBox__WbyjV`,
	"colorPickIcon": `GroupCreate_colorPickIcon__wOMNV`,
	"programContainerBox": `GroupCreate_programContainerBox__WCRXc`
};
export default ___CSS_LOADER_EXPORT___;
